import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      // Extract session_id from URL hash (not query params)
      const hash = location.hash.substring(1); // Remove '#'
      const params = new URLSearchParams(hash);
      const sessionId = params.get('session_id');

      if (!sessionId) {
        console.error('No session_id found');
        navigate('/login');
        return;
      }

      try {
        // Exchange session_id for user data via backend
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/google/session`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include', // Important for cookies
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!response.ok) {
          throw new Error('Failed to process session');
        }

        const data = await response.json();
        
        console.log('✅ Google OAuth successful, user:', data.user);
        
        // Update auth context using the proper method
        setUser(data.user);

        // Redirect to the intended page (stored before Google redirect) or account
        const returnPath = sessionStorage.getItem('authReturnPath') || '/account';
        sessionStorage.removeItem('authReturnPath');
        navigate(returnPath, { 
          replace: true,
          state: { user: data.user }
        });
      } catch (error) {
        console.error('Auth error:', error);
        navigate('/login');
      }
    };

    processSession();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
